import { useGetMsftCoSellEnumsQuery } from 'packages/tackle-api/src/co-sell-msft';
import { useMemo } from 'react';

export default function useCurrencyOptions() {
  const enums = useGetMsftCoSellEnumsQuery({ enabled: true });

  const currencyEnums = enums?.data?.['details.currency'];
  const currencyOptions = useMemo(() => {
    return (
      currencyEnums?.map((option) => ({
        display: String(option.display),
        value: String(option.value),
      })) ?? []
    );
  }, [currencyEnums]);

  return currencyOptions;
}
